(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('search', Search)

    /** @ngInject */
    function Search($rootScope, $timeout, $window, HttpService, HelperService, FileService, AuthenticationService, ModuleService, PATHS, DATA_EVENTS, ROUTES) {
        function SearchController($scope) {
            const vm = this;
            let userData = AuthenticationService.getUserData();

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                userData = AuthenticationService.getUserData();
            })

            let removeSearchWatch = $scope.$watch('vm.show', () => {
                if (vm.show)
                    init();
            })

            let removeWatchWindow = angular.element($window).on('resize', () => {
                $rootScope.isMobile = HelperService.isScreenSmaller(991);

                $timeout(() => {
                    vm.isMobile = $rootScope.isMobile;
                });
            });

            $scope.$on('$destroy', () => {
                removeSearchWatch();
                removeWatchUnit();
                removeWatchWindow();
            })

            vm.hideSearch = () => {
                $rootScope.showSearch = !$rootScope.showSearch;
            }

            vm.doSearch = () => {
                if (!vm.search)
                    return;

                HelperService.startLoading('.search-loader');

                vm.searchQuery = angular.copy(vm.search);

                let url = `?q=${vm.search}&responsibilityId=${userData.Responsibility.Id}`;

                if (vm.selectedModule)
                    url = url.concat(`&moduleId=${vm.selectedModule.Id}`);

                HttpService.get(`/search${url}`)
                    .then(
                        success => {
                            vm.results = success;
                            vm.numberOfResults = success.NumberOfResults;
                            vm.isFirstCall = false;

                            $timeout(() => {
                                $.fn.scrollbar && $('.search-body').scrollbar({
                                    ignoreOverlay: false
                                });

                                HelperService.stopLoading('.search-loader');
                            })
                        },
                        error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.search-loader');
                        }
                    );
            }

            vm.downloadFile = file => {
                let accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

                return FileService
                    .verifyDownload(file.Id)
                    .then(() => $window.location.href = `${ROUTES.API}/files/download/${userData.Id}/${file.Id}?accessToken=${accessToken}`, error => HelperService.errorCallback(error));
            }

            vm.getFileIcon = file => {
                return HelperService.imageHandlerFileIcon(file.Extension.trim());
            }

            vm.formatSize = FileService.formatSize;

            function getModules() {
                return ModuleService
                    .getAll(true)
                    .then(success => {
                        vm.modules = success.sort((a, b) => {
                            return a.Title > b.Title;
                        });
                    }, error => HelperService.errorCallback(error));
            }

            function init() {
                vm.results = [];
                vm.selectedModule = null;
                vm.isMobile = $rootScope.isMobile;

                vm.searchForm.reset();
                vm.search = null;

                vm.numberOfResults = 0;
                vm.isFirstCall = true;

                getModules();
            }
        }

        return {
            bindToController: true,
            controller: SearchController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/search/search.html`,
            scope: {
                show: '='
            }
        }
    }
}());